import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    Link,
    Heading,
    Image,
    Radio,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {storeItem} from './index.style'
import {useIntl} from 'react-intl'
import StoreHoursTable from './storeHoursTable'
//import {CloseIcon, CheckIcon, StarIcon} from '@salesforce/retail-react-app/app/components/icons'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {pxToRem} from '../../utills/pxToRem'
import PropTypes from 'prop-types'

const Store = ({store, isMaster, isPdp, isDefaultStore = false}) => {
    const intl = useIntl()

    const {
        id,
        name,
        address1,
        city,
        stateCode,
        postalCode,
        phone,
        c_firstHoursOnline,
        c_firstHoursDefault,
        c_firstHoursRows,
        c_firstHoursName,
        c_secondHoursOnline,
        c_secondHoursDefault,
        c_secondHoursRows,
        c_secondHoursName,
        c_thirdHoursOnline,
        c_thirdHoursDefault,
        c_thirdHoursRows,
        c_thirdHoursName,
        c_fourthHoursOnline,
        c_fourthHoursDefault,
        c_fourthHoursRows,
        c_fourthHoursName,
        c_fifthHoursOnline,
        c_fifthHoursDefault,
        c_fifthHoursName,
        c_fifthHoursRows
    } = store

    return (
        <>
            <Box sx={storeItem}>
                <Box className={isPdp ? 'radioPdp radio' : 'radio'}>
                    <Radio key={id} value={id}></Radio>
                </Box>
                <Box className={isPdp ? 'detailsPdp details' : 'details'}>
                    {/* store name */}
                    <Heading as="h3">{name}</Heading>

                    {/* display in case of PDP when product is not master */}
                    {isPdp && isDefaultStore && (
                        <Box className="defaultStoreLabel">
                            <Image
                                src={getAssetUrl('static/img/plp/star.svg')}
                                sx={{height: pxToRem(14), width: pxToRem(14)}}
                                alt="default store"
                            />
                            <Text>
                                {intl.formatMessage({
                                    id: 'pdp.storeSelector.defaultStore.label',
                                    defaultMessage: 'My Default Store'
                                })}
                            </Text>
                        </Box>
                    )}

                    <Box className="address">
                        <Text>{address1}</Text>
                        <Text>
                            {city}, {stateCode} {postalCode}
                        </Text>
                    </Box>
                    <Link href={'javascript:void(0);'} className="phoneNotForMobile">
                        +1 {phone}
                    </Link>
                    <Link href={`tel:+1 ${phone}`} className="phoneForMobile">
                        +1 {phone}
                    </Link>

                    {isPdp ? (
                        <Box paddingTop={pxToRem(12)}>
                            <Link href={store?.c_storeDetailsLink?.replace('/s/Cavenders', '')}>
                                {intl.formatMessage({
                                    id: 'plp.storeSelector.viewStoreHour.label',
                                    defaultMessage: 'View Store Hours'
                                })}
                            </Link>
                        </Box>
                    ) : (
                        <Accordion allowToggle>
                            <AccordionItem>
                                <h2>
                                    <AccordionButton>
                                        <Box as="span" flex="1" textAlign="left">
                                            <Text>
                                                {intl.formatMessage({
                                                    id: 'plp.storeSelector.viewStoreHour.label',
                                                    defaultMessage: 'View Store Hours'
                                                })}
                                            </Text>
                                        </Box>
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel>
                                    <StoreHoursTable
                                        hoursOnline={c_firstHoursOnline}
                                        hoursDefault={c_firstHoursDefault}
                                        hoursRows={c_firstHoursRows}
                                        hoursName={c_firstHoursName}
                                    />
                                    <StoreHoursTable
                                        hoursOnline={c_secondHoursOnline}
                                        hoursDefault={c_secondHoursDefault}
                                        hoursRows={c_secondHoursRows}
                                        hoursName={c_secondHoursName}
                                    />
                                    <StoreHoursTable
                                        hoursOnline={c_thirdHoursOnline}
                                        hoursDefault={c_thirdHoursDefault}
                                        hoursRows={c_thirdHoursRows}
                                        hoursName={c_thirdHoursName}
                                    />
                                    <StoreHoursTable
                                        hoursOnline={c_fourthHoursOnline}
                                        hoursDefault={c_fourthHoursDefault}
                                        hoursRows={c_fourthHoursRows}
                                        hoursName={c_fourthHoursName}
                                    />
                                    <StoreHoursTable
                                        hoursOnline={c_fifthHoursOnline}
                                        hoursDefault={c_fifthHoursDefault}
                                        hoursRows={c_fifthHoursRows}
                                        hoursName={c_fifthHoursName}
                                    />
                                </AccordionPanel>
                            </AccordionItem>
                        </Accordion>
                    )}
                </Box>

                {!isMaster && isPdp && (
                    <Box className="availableRow">
                        {store?.c_statusclass === 'store-in-stock' ? (
                            <Box className="availableBox">
                                <Image
                                    src={getAssetUrl('static/img/plp/available.svg')}
                                    height="15.825"
                                    width="14.8"
                                    alt="available today"
                                />
                                {intl.formatMessage({
                                    id: 'pdp.storeSelector.availableToday.label',
                                    defaultMessage: 'Available Today'
                                })}
                            </Box>
                        ) : (
                            <Box>
                                <Box className="availableBox notAvailable">
                                    <Image
                                        src={getAssetUrl('static/img/plp/not_available.svg')}
                                        height="15.825"
                                        width="14.8"
                                        alt="not avaialable"
                                    />
                                    {intl.formatMessage({
                                        id: 'pdp.storeSelector.notAvailable.label',
                                        defaultMessage: 'Not Available'
                                    })}
                                </Box>
                            </Box>
                        )}
                    </Box>
                )}
            </Box>
        </>
    )
}

Store.propTypes = {
    store: PropTypes.object.isRequired,
    isMaster: PropTypes.bool,
    isPdp: PropTypes.bool,
    isDefaultStore: PropTypes.bool
}

export default Store
